import React, {Fragment} from 'react';
import EfeTable from '../../../components/efe-table/EfeTable';
import {Box, Grid} from '@material-ui/core';
import {ERROR_DETAIL, ERRORS} from '../../../commons/constants/TableColumns';
import {EfeButtonPrimary} from '../../../components';
import {Sync} from '@material-ui/icons';
import {
    LogDetailResponse,
    LogErrorsResponse,
} from '../../../commons/models/dtos/logs/Logs';
import {TableAction} from '../../../commons/models/components/EfeTableValues';
import {EfeResponse} from '../../../commons/models';
import {ClientService} from '../../../services';
import {Messages, SnackbarVariants} from '../../../commons/constants';
import {useSnackbar} from 'notistack';
import {useSpinner} from '../../../hooks';

type Props = {
    page: number;
    rowsPerPage: number;
    kycId: string | number,
    handleChangePage: (page: number) => void;
    handleChangeRowsPerPage: (perPage: number) => void;
    getErrors: (kycId: number | string) => void;
    data?: LogErrorsResponse;
}

let processId = 0;
let page = 1;
let rows = 100;
export default function LogErrors(props: Props) {
    const {kycId} = props;
    const {enqueueSnackbar} = useSnackbar();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const {handleChangePage, handleChangeRowsPerPage, getErrors, data} = props;
    const [details, setDetails] = React.useState<LogDetailResponse>();

    async function handleTableAction(tableCellData: TableAction) {
        if (tableCellData?.data?.processId) {
            await getDetails(tableCellData?.data?.processId);
            processId = tableCellData?.data?.processId;
        }
    }

    async function handleChangePageDetail(newPage: number) {
        page = newPage;
        await getDetails(processId, newPage);
    }

    async function handleChangeRowsPerPageDetail(newRows: number) {
        page = 1;
        rows = newRows;
        await getDetails(processId, 1, rows);
    }

    async function getDetails(processId: number, page = 1, pageSize = 100) {
        try {
            setDetails(undefined);
            setIsLoading(true);
            const response: EfeResponse<LogDetailResponse> = await ClientService.getLogDetail({
                page: page,
                pageSize: pageSize,
                processId: processId,
            });
            if (response && response.data && response.data.data && response.data.data.length) {
                setDetails(response.data);
            }
            setIsLoading(false);
        } catch (e: any) {
            setIsLoading(false);
            setDetails(undefined);
            if (e.code === 404) {
                enqueueSnackbar(Messages.LOGS_NOT_FOUND, {
                    variant: SnackbarVariants.WARNING,
                });
            } else {
                enqueueSnackbar(Messages.LOGS_ERROR, {
                    variant: SnackbarVariants.WARNING,
                });
            }
        }
    }

    return (
        <Fragment>
            {isLoading && useSpinner(isLoading)}
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={6} sm={4}>
                        <Box pt={8}>
                            <EfeButtonPrimary
                                onClick={() => getErrors(kycId)}
                                type="submit"
                                disabled={false}
                                startIcon={<Sync />}>
                                {'Actualizar'}
                            </EfeButtonPrimary>
                        </Box>
                    </Grid>
                </Grid>
                {data && data.data && data.data.length &&
                    <EfeTable
                        title={'Bit\u00E1cora de proceso'}
                        page={1}
                        rowsPerPage={100}
                        data={data.data}
                        totalElements={data.pagination.totalElements}
                        columns={ERRORS}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        handleAction={handleTableAction}
                    />
                }
            </Box>
            <Box>
                {details && details.data && details.data.length &&
                    <EfeTable
                        title={'Detalle de errror'}
                        page={page}
                        rowsPerPage={rows}
                        data={details.data}
                        totalElements={details.pagination.totalElements}
                        columns={ERROR_DETAIL}
                        handleChangePage={handleChangePageDetail}
                        handleChangeRowsPerPage={handleChangeRowsPerPageDetail}
                    />
                }
            </Box>
        </Fragment>
    );
}
